// extracted by mini-css-extract-plugin
module.exports = {"headerIconStyle":"MerchandiseDetailsFormGroup_headerIconStyle__2zGXc","shiprocketContainer":"MerchandiseDetailsFormGroup_shiprocketContainer__1Ugkr"};